import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import { Box, Paper, Typography } from '@mui/material';
import React from 'react';
import { maxLength, ReferenceInput, required, SelectInput, TextInput } from 'react-admin';
import { getChainId } from '../../../lib';

const MAX_LENGTH_NAME = 100;
const MAX_LENGTH_DESCRIPTION = 500;

const FormBasicInfo: React.FC = () => {
  const chainId = getChainId();

  return (
    <Box sx={{ py: 2 }}>
      {/* Cabeçalho */}
      <Box sx={{ mb: 3 }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <CardGiftcardIcon color="primary" />
          <Typography variant="h6" fontWeight={600}>
            Informações Básicas
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary" paragraph>
          O nome e a descrição do brinde são exibidos diretamente no aplicativo do cliente.
          Capriche — eles precisam ser atrativos para o cliente querer abrir e participar.
        </Typography>
      </Box>

      {/* Info Box */}
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 3,
          backgroundColor: '#fff3e0',
          border: '1px solid #ffb74d',
        }}
      >
        <Typography variant="body2" color="text.secondary">
          <strong>⚠️ Visível no app:</strong> O nome e a descrição aparecem na listagem de brindes dentro do aplicativo.
          Evite nomes internos como "Promo Janeiro" ou "Teste Barbearia".
          Prefira algo que desperte interesse, como <strong>"Abasteça e Ganhe um Café!"</strong> ou <strong>"Desconto Exclusivo em Diesel"</strong>.
        </Typography>
      </Paper>

      {/* Formulário */}
      <Paper elevation={2} sx={{ p: 3 }}>
        <Box sx={{ mb: 3 }}>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Nome do Brinde (visível no app)
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            O cliente verá este nome na listagem de brindes. Seja atrativo e claro sobre o benefício.
          </Typography>
          <TextInput
            source="name"
            label="Ex: Abasteça 50L e Ganhe um Café Grátis!"
            InputProps={{ autoComplete: 'off' }}
            fullWidth
            validate={[required('O nome é obrigatório'), maxLength(MAX_LENGTH_NAME, `Máximo de ${MAX_LENGTH_NAME} caracteres`)]}
            helperText={`Título exibido no app do cliente (máx. ${MAX_LENGTH_NAME} caracteres). Use algo chamativo!`}
          />
        </Box>

        <Box>
          <Typography variant="subtitle2" fontWeight={600} gutterBottom>
            Descrição (visível no app, opcional)
          </Typography>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            Aparece logo abaixo do nome. Explique brevemente como participar ou o que o cliente ganha.
          </Typography>
          <TextInput
            source="description"
            label="Ex: Abasteça gasolina em qualquer posto da rede e ganhe um café na loja de conveniência."
            InputProps={{ autoComplete: 'off' }}
            fullWidth
            multiline
            rows={4}
            validate={[maxLength(MAX_LENGTH_DESCRIPTION, `Máximo de ${MAX_LENGTH_DESCRIPTION} caracteres`)]}
            helperText={`Descrição exibida no app (opcional, máx. ${MAX_LENGTH_DESCRIPTION} caracteres)`}
          />
        </Box>

        {/* Plano Vinculado */}
        <Box sx={{ mt: 3 }}>
          <Box display="flex" alignItems="center" gap={1} mb={1}>
            <CardMembershipIcon color="secondary" fontSize="small" />
            <Typography variant="subtitle2" fontWeight={600}>
              Plano Vinculado (Opcional)
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 2 }}>
            Se selecionado, o cliente que conquistar este brinde entrará automaticamente no plano escolhido
          </Typography>
          <ReferenceInput
            source="planId"
            reference="plans"
            filter={{ chainId, isEnabled: true }}
            sort={{ field: 'priority', order: 'ASC' }}
            perPage={100}
          >
            <SelectInput
              label="Plano"
              optionText="name"
              emptyText="Nenhum plano"
              fullWidth
              helperText="Ao conquistar este brinde, o cliente entra no plano selecionado"
            />
          </ReferenceInput>
        </Box>
      </Paper>
    </Box>
  );
};

export default React.memo(FormBasicInfo);
